import BeautyHealthIcon from '@/assets/categories/BeautyHealth.svg?component'
import BooksGamesIcon from '@/assets/categories/Books.svg?component'
import ChildrenBabyIcon from '@/assets/categories/ChildrenBaby.svg?component'
import ElectronicsComputersIcon from '@/assets/categories/ElectronicsComputers.svg?component'
import FashionIcon from '@/assets/categories/Fashion.svg?component'
import FoodBeverageIcon from '@/assets/categories/Food.svg?component'
import HomeInteriorIcon from '@/assets/categories/HomeInterior.svg?component'
import OtherIcon from '@/assets/categories/Other.svg?component'
import SportsOutdoorsIcon from '@/assets/categories/SportsOutdoors.svg?component'

export const CATEGORIES = [
  {
    id: 1,
    name: 'Fashion',
    icon: FashionIcon,
  },
  {
    id: 2,
    name: 'Home & Interior',
    icon: HomeInteriorIcon,
  },
  {
    id: 3,
    name: 'Beauty & Health',
    icon: BeautyHealthIcon,
  },
  {
    id: 4,
    name: 'Electronics & Computers',
    icon: ElectronicsComputersIcon,
  },
  {
    id: 5,
    name: 'Children & Baby',
    icon: ChildrenBabyIcon,
  },
  {
    id: 6,
    name: 'Sports & Outdoors',
    icon: SportsOutdoorsIcon,
  },
  {
    id: 7,
    name: 'Books & Games',
    icon: BooksGamesIcon,
  },
  {
    id: 8,
    name: 'Food & Beverage',
    icon: FoodBeverageIcon,
  },
  {
    id: 9,
    name: 'Other',
    icon: OtherIcon,
  },
]
